import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { StateBadge } from '@/components/StateBadge';
import { formatDistanceToNow } from 'date-fns';

export function InboxPage(): JSX.Element {
  const me = useQuery({ queryKey: ['me'], queryFn: () => api.me() });
  const pending = useQuery({
    queryKey: ['pending', me.data?.user.id],
    queryFn: () => api.listPending(me.data?.user.id),
    enabled: !!me.data?.user.id,
  });

  return (
    <div className="space-y-4 max-w-4xl">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">Inbox</h2>
        <p className="text-sm text-muted-foreground">
          Tasks awaiting your input — approvals, reviews, clarifications, and guardrail decisions.
        </p>
      </div>

      <Card>
        {pending.isLoading && <div className="p-6 text-sm text-muted-foreground">Loading…</div>}
        {pending.data?.pending.length === 0 && (
          <div className="p-6 text-sm text-muted-foreground">All clear. No pending work.</div>
        )}
        {pending.data?.pending.map(({ pending: p, task }) => (
          <Link
            key={p.id}
            to={`/tasks/${task.id}`}
            className="block px-4 py-3 hover:bg-accent/50 transition-colors border-b last:border-b-0"
          >
            <div className="flex items-center gap-3">
              <div className="flex-1 min-w-0">
                <div className="font-medium truncate">{task.name}</div>
                <div className="text-xs text-muted-foreground mt-0.5">
                  pending for {formatDistanceToNow(new Date(p.created_at), { addSuffix: true })}
                </div>
              </div>
              <Badge variant="info">{p.reason}</Badge>
              <StateBadge state={task.state} pauseReason={task.pause_reason} />
            </div>
          </Link>
        ))}
      </Card>
    </div>
  );
}
